import {Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AppService } from '../../services/app.service';

import { StateService } from 'src/app/services/states.service';

@Component({
    selector: 'mess_changemdp_dialog',
    templateUrl: 'mess_changemdp_dialog.component.html',
    styleUrls: ['mess_changemdp_dialog.component.scss']
})
export class MessChangeMDP implements OnInit {
    signupForm: FormGroup = new FormGroup({});
    user:any = "";
    special = 0;
    uppercase = 0;
    integer = 0;
    errormdp: boolean;
    succesmdp: boolean;
    errorRequete: boolean;

    constructor(
        private stateService: StateService,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<MessChangeMDP>,
        private appService: AppService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.stateService.user.subscribe((user) => {
            this.user = user;
            this.signupForm = this.formBuilder.group({
                password: new FormControl(""),
                confpassword: new FormControl(""),
            });
        });
    }

    checkPassword(event){
        let regexInteger : RegExp = /[0-9]/;
        let regexUppercase : RegExp = /[A-Z]/;
        let regexSpecial : RegExp = /[^ \w]/;
        regexSpecial.test(event.target.value) ? this.special = 1 : this.special = 0;
        regexUppercase.test(event.target.value) ? this.uppercase = 1 : this.uppercase = 0;
        regexInteger.test(event.target.value) ? this.integer = 1 : this.integer = 0;
    }

    dismissDialog(){
        this.dialogRef.close();
    }
    
    closePopup(step){
        if(step === 2){
            this.dismissDialog();
        }else if(step === 3){
            this.dialogRef.close({event:step})
        }
    }

    validateForm(){
        this.errormdp = false;
        this.succesmdp = false;
        this.errorRequete = false;
        if(this.signupForm.get('password').value != this.signupForm.get('confpassword').value){
            this.errormdp = true;
        } else {
            let res = this.signupForm.getRawValue();
            this.appService.updatePassword(this.user.ID, res.password).subscribe((resRegister) => {
                if(resRegister.result.connect == "OK")
                    this.succesmdp = true;
                else
                    this.errorRequete = true;
            });
        }
    }
}